import "./NlpSideBar.css";
import React, {useEffect, useState} from "react";
import NlpSideBarSearchBar from "./NlpSideBarSearchBar/NlpSideBarSearchBar";
import NlpSideBarStatusLabels from "./NlpSideBarStatusLabels/NlpSideBarStatusLabels";
import NlpSideBarCustomersList from "./NlpSideBarCustomersList/NlpSideBarCustomersList";

const NlpSideBar: React.FC = () => {

    return (
        <div className="NlpSideBar">
            <NlpSideBarSearchBar></NlpSideBarSearchBar>
            <NlpSideBarStatusLabels></NlpSideBarStatusLabels>
            <NlpSideBarCustomersList></NlpSideBarCustomersList>
        </div>
    );
};

export default NlpSideBar;
